var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 2.33331H4.66536C2.66536 2.33331 1.33203 3.33331 1.33203 5.66665V10.3333C1.33203 12.6666 2.66536 13.6666 4.66536 13.6666H11.332C13.332 13.6666 14.6654 12.6666 14.6654 10.3333V5.66665C14.6654 3.33331 13.332 2.33331 11.332 2.33331ZM11.6454 6.39331L9.5587 8.05998C9.1187 8.41331 8.5587 8.58665 7.9987 8.58665C7.4387 8.58665 6.87203 8.41331 6.4387 8.05998L4.35203 6.39331C4.1387 6.21998 4.10536 5.89998 4.27203 5.68665C4.44536 5.47331 4.7587 5.43331 4.97203 5.60665L7.0587 7.27331C7.56536 7.67998 8.42536 7.67998 8.93203 7.27331L11.0187 5.60665C11.232 5.43331 11.552 5.46665 11.7187 5.68665C11.892 5.89998 11.8587 6.21998 11.6454 6.39331Z",
    fill: "#7E7E80"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email.48a60e3f.svg";
export { ForwardRef as ReactComponent };